'use strict';

import {
  addClassToElement,
  classes,
  removeClassToElement
} from '@jspartials/class-list-utils';
import { listenDOMEvent } from '@jspartials/dom-api-utils';

const selector = {
  link: '.js-legal-link',
  subLink: '.js-legal-sub-link',
  title: '.js-legal-title',
  subTitle: '.js-legal-sub-title'
};

const element = {
  links: document.querySelectorAll(selector.link) || [],
  subLinks: document.querySelectorAll(selector.subLink) || [],
  titles: document.querySelectorAll(selector.title) || [],
  subTitles: document.querySelectorAll(selector.subTitle) || []
};

const clearLinks = () => {
  element.links.forEach((item) => {
    removeClassToElement(item, classes.is.selected);
  });
};

const clearSubLinks = () => {
  element.subLinks.forEach((item) => {
    removeClassToElement(item, classes.is.selected);
  });
};

const markLinkAsSelected = (link) => {
  addClassToElement(link, classes.is.selected);
};

const goToTarget = (link) => {
  const targetID = link.dataset.target;
  const targetElement = document.getElementById(targetID);
  if (targetElement) {
    const targetPosition = targetElement.offsetTop - 82;
    window.scrollTo({ top: targetPosition, behavior: 'smooth' });
  }
};

const clickOnLink = (link) => {
  clearLinks();
  markLinkAsSelected(link);
  goToTarget(link);
};

const clickOnSubLink = (link) => {
  clearSubLinks();
  markLinkAsSelected(link);
  goToTarget(link);
};

const listenLinks = () => {
  element.links.forEach((link) => {
    listenDOMEvent(link, 'click', () => clickOnLink(link));
  });

  element.subLinks.forEach((link) => {
    listenDOMEvent(link, 'click', () => clickOnSubLink(link));
  });
};

const observeSections = () => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const id = entry.target.id;
        const mainLink = document.querySelector(
          `${selector.link}[data-target="${id}"]`
        );
        const subLink = document.querySelector(
          `${selector.subLink}[data-target="${id}"]`
        );

        if (mainLink) {
          clearLinks();
          markLinkAsSelected(mainLink);
        }

        if (subLink) {
          clearSubLinks();
          markLinkAsSelected(subLink);
        }
      });
    },
    {
      rootMargin: '0px 0px -80% 0px',
      threshold: 0
    }
  );

  [...element.titles, ...element.subTitles].forEach((el) => {
    observer.observe(el);
  });
};

document.addEventListener('DOMContentLoaded', function () {
  listenLinks();
  observeSections();
});
